interface JsonLdItem {
  "@context": string;
  [key: string]: unknown;
}

export default function JsonLd({ data }: { data: JsonLdItem[] }) {
  return (
    <>
      {data.map((item, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}